import { render } from "./BoostButton.vue?vue&type=template&id=1605420a&scoped=true"
import script from "./BoostButton.vue?vue&type=script&lang=js"
export * from "./BoostButton.vue?vue&type=script&lang=js"

import "./BoostButton.vue?vue&type=style&index=0&id=1605420a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1605420a"]])

export default __exports__